import { Labels } from 'index.d'

export default {
  loading: 'Laster opp...',
  addNewTab: 'Legg til nye fane',
  addNewWidgets: 'Legg til nye widgeter',
  arrangeWidgets: 'Ordne widgets, og lagre eller avbryt endringer',
  cancelChanges: 'Glem endringer',
  deleteTab: 'Fjern fane',
  deleteWidgetAreYouSure1: 'Er du sikker på at du vil slett dette widget?',
  deleteWidgetAreYouSure2: 'Du kan legg til andre senere, men alle innstillinger vil gå tapt',
  discardChanges: 'Glem endringene og fortsett med forrige dashbord',
  dragNewWidgets: 'Dra nye widgeter til dashbordet',
  dragHereToMoveWidget: 'Dra her for å flytte widgeten',
  editDashboard: 'Rediger dashbordet',
  editTabTitle: 'Rediger fanes tittel',
  hideNewWidgets: 'Skjule nye widgeter',
  moveTabToLeft: 'flytt fanen til venstre',
  moveTabToRight: 'flytt fanen til høyre',
  noWidgetForType: 'Ingen widget til type {{type}}',
  reset: 'Nullstill dashbordet',
  resetDashboard: 'Nullstill dashbordet til startformat',
  saveChanges: 'Lagre endringer',
  saveDashboard: 'Lagre endringene du gjorde på dashbordet',
  yes_delete: 'Yes, delete',
  no_cancel: 'No, cancel'
} as Labels
